exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search_member-popup .ant-modal-footer {\n  padding: 10px 16px;\n  text-align: right;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 6px 6px;\n  display: none;\n}\n", ""]);

// exports
